'use strict';
import angular from 'angular';
import _ from 'lodash';

import connectionsListHtmlUrl from './views/connections.list.html';

var app = angular.module('connections.component', []);

app.component('connectionsList', {
    bindings: {
        showActions: '=',
        selectedConnections: '=',
        clusterId: '='
    },
    templateUrl: connectionsListHtmlUrl,

    // The controller that handles our component logic
    controller: function(ProductService, FormService) {
        var self = this;
        self.bandwidthSearch = "";
        self.carrierSearch = "";
        self.connectionWidget = [];
        self.includeOrExcludeBandwidth = null;
        self.includeOrExcludeMobile = null;
        var bandwidthCount = 0;
        var mobileCarrierCount = 0;

        self.contentKeys = ['dfp_bandwidth_groups', 'dfp_mobile_carriers'];
        self.bandwidths = [];
        self.mobileCarriers = [];
        self.userDomains = [];
        self.userDomainObj = {
            conditionType: 'include',
            domainUrl: ''
        };

        self.toggleDomainCriteria = function(criteria) {
            self.selectedConnections.userDomains.conditionType = criteria;
            self.userDomainObj.conditionType = criteria;
        }

        /*
        * Handle domain url validation
        */
        self.validateDomains = function() {
            var userDomains = self.userDomainObj.domainUrl.split(/,| |\n/);
            if(userDomains && _.isArray(userDomains)) {
                self.userDomainObj.domainUrl = "";
                var processedDomains = [];
                _.each(userDomains, function(domain) {
                    if(domain != "") {
                        processedDomains.push(domain);
                    }
                })
                if(processedDomains && _.isArray(processedDomains)) {
                    var domainRegex = /^(?!(https:\/\/|http:\/\/|www\.|mailto:|smtp:|ftp:\/\/|ftps:\/\/))(((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,86}[a-zA-Z0-9]))\.(([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,73}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25})))|((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,162}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25}))))$/;
                    _.each(processedDomains, function(domain) {
                        self.selectedConnections.userDomains.domainUrls.push(domain);
                    })
                    self.selectedConnections.userDomains.conditionType = self.userDomainObj.conditionType;
                    if(self.userDomainObj.domainUrl && self.userDomainObj.domainUrl.length < 0) {
                        self.showError = true;
                    } else {
                        self.showError = false;
                    }
                }
            }
        }

        /*
        * Handle clear all domains
        */
        self.handleClearAllDomains = function() {
            self.selectedConnections.userDomains.domainUrls = [];
        }

        self.changeConnectionIncludeExclude = function(item, criteria, data, type) {
            self.connectionWidget = data;
            var index = self.connectionWidget.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    self.connectionWidget[index].criteria = 'include';
                    self.connectionWidget[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    self.connectionWidget[index].criteria = 'exclude';
                    self.connectionWidget[index].criteria_link = 'excluded';
                } else {
                    self.connectionWidget[index].criteria = '';
                    self.connectionWidget[index].criteria_link = 'include';
                }

                if(type === 'bandwidth') {
                    if(bandwidthCount < 1) {
                        self.includeOrExcludeBandwidth = criteria + 'bandwidth';
                    }
                    var selIndex = _.findIndex(self.selectedConnections.bandwidths, { id: self.connectionWidget[index].id });
                    if (selIndex >= 0) {
                        self.selectedConnections.bandwidths[selIndex] = self.connectionWidget[index];
                    } else {
                        self.selectedConnections.bandwidths.push(self.connectionWidget[index]);
                    }
                    bandwidthCount++;
                } else if(type === 'mobileCarrier') {
                    if(mobileCarrierCount < 1) {
                        self.includeOrExcludeMobile = criteria + 'carrier';
                    }
                    var selIndex = _.findIndex(self.selectedConnections.mobileCarriers, { id: self.connectionWidget[index].id });
                    if (selIndex >= 0) {
                        self.selectedConnections.mobileCarriers[selIndex] = self.connectionWidget[index];
                    } else {
                        self.selectedConnections.mobileCarriers.push(self.connectionWidget[index]);
                    }
                    mobileCarrierCount++;
                }
            }
        }

        self.removeDomain = function(item, selectedDomains) {
            var selIndex = selectedDomains.indexOf(item);
            if (selIndex >= 0) {
                selectedDomains.splice(selIndex, 1);
            }
        }

        self.removeConnection = function(item, selectedConnection, connectionsData, type) {
            var selIndex = selectedConnection.indexOf(item);
            if (selIndex >= 0) {
                selectedConnection.splice(selIndex, 1);
                if(selIndex === 0  && selectedConnection.length == 0) {
                    if(type === 'bandwidth') {
                        bandwidthCount = 0;
                        self.includeOrExcludeBandwidth = null;
                    } else {
                        mobileCarrierCount = 0;
                        self.includeOrExcludeMobile = null;
                    }
                }
            }
            var index = _.findIndex(connectionsData, { id: item.id });
            if (index >= 0) {
                connectionsData[index].criteria = '';
                connectionsData[index].criteria_link = 'include';
            }
        }

        self.clearSelectedConnections = function (type, connectionsData) {
            if (type == "bandwidth") {
                self.selectedConnections.bandwidths = [];
                bandwidthCount = 0;
                self.includeOrExcludeBandwidth = null;
            }
            else if (type == "mobileCarrier") {
                self.selectedConnections.mobileCarriers = [];
                mobileCarrierCount = 0;
                self.includeOrExcludeMobile = null;
            }
            _.map(connectionsData, function (item) {
                item.criteria = '';
                item.criteria_link = 'include';
            });
        }

        /*
        * get connections lookup contents
        */
        self.getConnectionsByContentKey = function() {
            _.each(self.contentKeys, function(contentKey) {
                ProductService.getDevicesByContentKey({clusterId: self.clusterId, contentKey: contentKey}).then(function(success) {
                    if(success && success.lookupContents && success.lookupContents.length > 0) {
                        _.each(success.lookupContents, function(content) {
                            var connection = {};
                            connection.id = content.id;
                            connection.name = content.lookup_value;
                            connection.criteria = "";
                            connection.criteria_link = "include";
                            if(contentKey === 'dfp_bandwidth_groups') {
                                self.bandwidths.push(connection);
                            } else if(contentKey === 'dfp_mobile_carriers') {
                                self.mobileCarriers.push(connection);
                            }
                        })
                        if(self.editMode && self.selectedConnections) {
                            var connectionList = [];
                            var subList = [];

                            if((self.selectedConnections.bandwidths && self.selectedConnections.bandwidths.length > 0) || (self.selectedConnections.mobileCarriers && self.selectedConnections.mobileCarriers.length > 0)) {
                                if(contentKey === 'dfp_bandwidth_groups') {
                                    connectionList = self.bandwidths;
                                    subList = self.selectedConnections.bandwidths;
                                    if (subList && subList.length > 0) {
                                        self.includeOrExcludeBandwidth = subList[0].criteria + 'bandwidth';
                                    }
                                } else if(contentKey === 'dfp_mobile_carriers') {
                                    connectionList = self.mobileCarriers;
                                    subList = self.selectedConnections.mobileCarriers;
                                    if (subList && subList.length > 0) {
                                        self.includeOrExcludeMobile = subList[0].criteria + 'carrier';
                                    }
                                }
                                processConnections(connectionList, subList);
                            }
                        }
                    }
                }, function(error) {});
            })
        }

        var processConnections = function(totalList, subList) {
            _.each(totalList, function(connection) {
                _.each(subList, function(subConnection) {
                    if(subConnection.id == connection.id) {
                        connection.criteria = subConnection.criteria;
                        connection.criteria_link = subConnection.criteria_link;
                    }
                })
            })
        }
        
        self.initComponent = function() {
            if(self.selectedConnections && !_.isEmpty(self.selectedConnections)){
                if(FormService.isValidJsonString(self.selectedConnections)){
                    self.selectedConnections = JSON.parse(self.selectedConnections);
                }
                if(self.showActions){
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getConnectionsByContentKey();
                }else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            }else {
                self.selectedConnections = {
                    bandwidths: [],
                    mobileCarriers: [],
                    userDomains: {
                        conditionType: '',
                        domainUrls: []
                    }
                };
                self.enableViewMode = false;
                self.getConnectionsByContentKey();
            }
        };

        self.initComponent();
    }
});